import React, { FC } from 'react';
import IconHelpCircle from '@zvuk-b2b/react-uikit/ui/icons/HelpCircle';

import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import styles from './index.module.scss';
import { TEXTS } from './texts';

interface HelpCenterLinkProps {
  link: string;
  onClick?: () => void;
  elementId: string;
}

const HelpCenterLink: FC<HelpCenterLinkProps> = ({ link, onClick, elementId }) => (
  <a
    onClick={onClick}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.wrapper}
    href={link}>
    <IconButton
      hint={TEXTS.HELP_CENTER_REPORTS_HINT}
      elementId={elementId}>
      <IconHelpCircle />
    </IconButton>
  </a>
);

export default HelpCenterLink;
